"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.assign");

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var components_1 = require("@lsg/components");

exports.StageCtaButton = function (_a) {
  var label = _a.label,
      href = _a.href,
      target = _a.target;

  if (label && href) {
    var buttonProps = {
      href: href,
      target: target
    };

    if (target === '_blank') {
      buttonProps.htmlAttrs = {
        rel: 'noopener'
      };
    }

    return React.createElement(components_1.Button, __assign({}, buttonProps), label);
  }

  return React.createElement(React.Fragment, null);
};